import { useRef, useEffect } from 'react';
import shallowEquals from 'shallowequal';
import deepEquals from 'fast-deep-equal';
export function usePreviousValue(value) {
  var cache = useRef(undefined);
  useEffect(function () {
    cache.current = value;
  }, [value]);
  return cache.current;
}
export function usePreviousEquals(value) {
  var equals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : shallowEquals;
  var previousValue = usePreviousValue(value);
  return equals(previousValue, value);
}
export function useOriginalCopy(value) {
  var equals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : shallowEquals;
  var cache = useRef(value);
  var equalsRef = useRef(equals);
  useEffect(function () {
    equalsRef.current = equals;
  }, [equals]);
  useEffect(function () {
    if (!equalsRef.current(cache.current, value)) {
      cache.current = value;
    }
  }, [value]);
  return equals(cache.current, value) ? cache.current : value;
}
export function useOriginalDeepCopy(value) {
  return useOriginalCopy(value, deepEquals);
}